module.exports = __webpack_public_path__ + "static/media/Practical-stress-logo.c9c45ff6.svg";